import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormEditor } from './../../../models/editors/form-editor.base.model';
import { FormGroup } from '@angular/forms';

import * as appConfig from '../../../app.config';
import { FilesService } from './../../../shared/services/files.service';

@Component({
  selector: 'swb-form-fields',
  templateUrl: './form-fields.component.html'
})
export class FormEditorsComponent implements OnInit, OnDestroy {
  @Input() fields: FormEditor<any>[];
  @Input() form: FormGroup;
  @Input() isModal: boolean;

  public langs: Array<string> = appConfig.languages.slice();
  public activeLangIndex = 0;
  public hasMultilang = false;

  constructor(
    private _filesService: FilesService
  ) { }

  ngOnInit() {

    /* hack for the AtLeastOne Validator! */
    this.form.valueChanges.subscribe(data => {
      Object.keys(this.form.controls).map((controlName) => {
        this.form.get(controlName).markAsTouched({ onlySelf: true });
        this.form.get(controlName).updateValueAndValidity({ onlySelf: true });
      });
    });

    if (this.fields[this.langs[0]].length > 0) {
      this.hasMultilang = true;
    }

  }

  public ngOnDestroy() {
    this._filesService.toggleBrowser({ open: false, height: 0 });
  }

  switchTab(langIndex: number) {
    this.activeLangIndex = langIndex;
  }

}
